import { render, staticRenderFns } from "./RouteTree.vue?vue&type=template&id=0c06d312&"
import script from "./RouteTree.vue?vue&type=script&lang=js&"
export * from "./RouteTree.vue?vue&type=script&lang=js&"
import style0 from "./RouteTree.vue?vue&type=style&index=0&id=0c06d312&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports